import React, { useState } from 'react';
import { Button, Form, ListGroup } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";

const AddPoll = ({ agenda, meetingId, getPolls }) => {
  const { user: authUser } = useSelector(x => x.auth);
  const url = process.env.REACT_APP_URL;

  const [showPollForm, setShowPollForm] = useState(false); // Toggle poll creation form
  const [pollTitle, setPollTitle] = useState(''); // Poll title
  const [selectedItems, setSelectedItems] = useState([]); // Selected agenda items

  const togglePollForm = () => setShowPollForm(!showPollForm);

  const handleSelectItem = (item) => {
    const itemData = {
      agendaEventName: item.agendaEvent.name,
      agendaItemId: item.agendaItemId,
      assignedUserAvatar: item.assignedUser?.avatar || null,
      assignedUserFirstName: item.assignedUser?.firstName || 'TBA',
      assignedUserLastName: item.assignedUser?.lastName || '',
      meetingRoleName: item.meetingRole?.name || 'N/A',
    };

    setSelectedItems((prevItems) =>
      prevItems.some((i) => i.agendaItemId === itemData.agendaItemId)
        ? prevItems.filter((i) => i.agendaItemId !== itemData.agendaItemId)
        : [...prevItems, itemData]
    );
  };

  const handleCreatePoll = async () => {
    if (!pollTitle || selectedItems.length === 0) {
      toast.error('Please provide a poll title and select at least one agenda item.', {
        position: 'bottom-left',
      });
      return;
    }

    const newPoll = {
      title: pollTitle,
      options: selectedItems.map((item) => ({
        firstName: item.assignedUserFirstName,
        lastName: item.assignedUserLastName,
        votes: 0, // Initialize votes for each option
      })),
      meeting: meetingId,
      status: 'ready',
    };

    try {
      const response = await fetch(`${url}/poll/${meetingId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authUser.token,
        },
        body: JSON.stringify(newPoll),
      });

      const data = await response.json();
      if (data.status === 'ready') {
        toast.success('Poll created successfully!', { position: 'bottom-left' });
        getPolls(); // Fetch updated polls
        setPollTitle(''); // Reset poll title
        setSelectedItems([]); // Reset selected items
        setShowPollForm(false); // Hide the form
      } else {
        toast.error('Failed to create poll. Please try again.', { position: 'bottom-left' });
      }
    } catch (error) {
      console.error('Error creating poll:', error);
      toast.error('An error occurred while creating the poll.', { position: 'bottom-left' });
    }
  };

  return (
    <>
      <Button
        variant="success"
        onClick={togglePollForm}
        className="mb-3 w-100"
      >
        {showPollForm ? 'Cancel Poll Creation' : 'Create Poll'}
      </Button>

      {showPollForm && (
        <Form data-bs-theme={'dark'} >
          <Form.Group controlId="pollTitle" className="mb-3">
            <Form.Label>Poll Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter poll title"
              value={pollTitle}
              onChange={(e) => setPollTitle(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="agendaItems" className="mb-3">
            <Form.Label>Select Agenda Items</Form.Label>
            <ListGroup>
              {agenda.map((item) => (
                <ListGroup.Item
                  key={item.agendaItemId}
                  active={selectedItems.some((i) => i.agendaItemId === item.agendaItemId)}
                  onClick={() => handleSelectItem(item)}
                >
                  {item.agendaEvent.name} - {item.assignedUser?.firstName || 'TBA'}{' '}
                  {item.assignedUser?.lastName || ''}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Form.Group>
          <Button
            variant="success"
            onClick={handleCreatePoll}
            className="w-100"
          >
            Create Poll
          </Button>
        </Form>
      )}
    </>
  );
};

export default AddPoll;